import { render, staticRenderFns } from "./campaign_status.vue?vue&type=template&id=0f8b54b2"
import script from "./campaign_status.vue?vue&type=script&lang=ts"
export * from "./campaign_status.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports